import { useState } from 'react';
import type { GeoHierarchyNode } from '../utils/destinationPicker';

export const usePrepackageDestinationHierarchy = (hierarchyUrl?: string) => {
    const [hierarchy, setHierarchy] = useState<GeoHierarchyNode[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const fetchHierarchy = async (): Promise<void> => {
        if (!hierarchyUrl || hierarchy.length > 0 || loading) return;

        setLoading(true);
        setError(false);
        try {
            const response = await fetch(hierarchyUrl);
            if (!response.ok) throw new Error(`Failed fetching geo hierarchy: ${response.status}`);
            setHierarchy((await response.json()) as GeoHierarchyNode[]);
        } catch {
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    return { hierarchy, loading, error, fetchHierarchy };
};
